import _ from 'lodash'
import { cleanOfferItemGroups } from './clean-offer-item-groups'
import { cleanOfferValue, cleanOfferDefaultPricing } from './clean-offer-value'

export function cleanOffers (menuBlob) {
  cleanOfferDefaultPricing(menuBlob)
  _.get(menuBlob, 'offers', []).forEach(offer => cleanOffer(offer, menuBlob))
}

export function cleanOffer (offer, menuBlob) {
  cleanOfferItemGroups(offer, menuBlob) // The order matters
  cleanOfferValue(offer, menuBlob) // The order matters
}
